
// Define operation types
export enum ScreenRenderStatus {
  SUCCESS = "SUCCESS",
  LOADING = "LOADING",
  ERROR = "ERROR",
}
// Define operation types
export enum OperationType {
  CREATE = "CREATE",
  EDIT = "EDIT",
  VIEW = "VIEW",
}

// Define action types
export enum ActionType {
  SET_SCREEN_RENDER_STATUS = "SET_SCREEN_RENDER_STATUS",
  SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE",
  SET_DATA = "SET_DATA",
  SET_OPERATION_TYPE = "SET_OPERATION_TYPE",
  SET_INPUT_CHANGE = "SET_INPUT_CHANGE",
  SET_SELECTED_FILE = "SET_SELECTED_FILE",
  SET_SELECTED_FILES = "SET_SELECTED_FILES",
  SET_UPLOAD_LOGS = "SET_UPLOAD_LOGS",
  SET_SIMULATION_LOGS = "SET_SIMULATION_LOGS",
  SET_IS_UPLOADING = "SET_IS_UPLOADING",
  SET_FILE_UPLOAD_UUID = "SET_FILE_UPLOAD_UUID",
  SET_IS_PROCESS_COMPLETED = "SET_IS_PROCESS_COMPLETED",
  SET_SIMULATION = "SET_SIMULATION",
  SET_COMPLETED_PDF_NAME = "SET_COMPLETED_PDF_NAME",
  SET_COMPLETED_PDF_NAMES = "SET_COMPLETED_PDF_NAMES",
  SET_PROCESSING_LOGS = "SET_PROCESSING_LOGS",
  SET_AUDIO_WORKFLOWS = "SET_AUDIO_WORKFLOWS",
  SET_AUDIO_WORKFLOWS_LOADING = "SET_AUDIO_WORKFLOWS_LOADING",
  SET_AUDIO_WORKFLOWS_ERROR = "SET_AUDIO_WORKFLOWS_ERROR",
  SET_AUDIO_WORKFLOWS_PAGINATION = "SET_AUDIO_WORKFLOWS_PAGINATION",
  SET_SHOW_UPLOAD_MODAL = "SET_SHOW_UPLOAD_MODAL",
}
